<template>
  <v-select
    :label="label"
    :items="items"
    item-text="name"
    item-value="id"
    v-model="selectedTemplateType"
    @change="onchange"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
    :multiple="multiple"
  />
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";

const ALL_TEMPLATE_TYPES_QUERY = gql`
  query allTemplateTypes {
    templateTypes {
      edges {
        node {
          id
          name
          notInUse
        }
      }
    }
  }
`;
export default {
  name: "template-type-list-select",
  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    label: {
      type: String,
      default: () => "Template Type",
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      selectedTemplateType: this.value
        ? this.multiple
          ? [...this.value]
          : this.value
        : null,
    };
  },

  computed: {
    items() {
      return this.templateTypes && this.templateTypes.edges
        ? this.templateTypes.edges.map(removeGQLTypename).filter((item) => {
            return this.value != ""
              ? item.id == this.value || !item.notInUse
              : !item.notInUse;
          })
        : [];
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.selectedTemplateType = this.multiple ? [...newVal] : newVal;
      } else {
        this.selectedTemplateType = null;
      }
    },
  },

  methods: {
    onchange(newVal) {
      this.$emit("input", newVal);
    },
  },

  apollo: {
    templateTypes: {
      query: ALL_TEMPLATE_TYPES_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/TemplateTypeListSelect.vue